<app-filter-header title="Filtrar Motivos de no notificación" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-filter-text-edit id="motiu-notif-filter-descripcio" class="col-sm-9" i18n-label label="Descripción" [(value)]="filter.descripcio" contains></app-filter-text-edit>
    <app-filter-text-edit id="motiu-notif-filter-codi" class="col-sm-3" i18n-label label="Código" [(value)]="filter.somId" contains number="true"></app-filter-text-edit>
  </div>
</div>
